import isClippedByAncestors from './isClippedByAncestors';

const isHiddenByStyle = (element: Element): boolean => {
  const style = window.getComputedStyle(element);

  return style.display === 'none' || style.visibility === 'hidden' || style.visibility === 'collapse';
};

const isHiddenByAncestor = (element: Element): boolean => {
  for (let node: Element | null = element; node; node = node.parentElement) {
    if (window.getComputedStyle(node).display === 'none') {
      return true;
    }
  }

  return false;
};

const isInsideViewport = (element: HTMLElement): boolean => {
  const rect = element.getBoundingClientRect();

  if (rect.width === 0 && rect.height === 0) {
    return true;
  }

  return rect.bottom > 0 && rect.right > 0 && rect.top < window.innerHeight && rect.left < window.innerWidth;
};

const isElementVisible = (element: HTMLElement): boolean => {
  if (!element.isConnected) {
    return false;
  }

  if (typeof element.checkVisibility === 'function') {
    return (
      element.checkVisibility({ checkVisibilityCSS: true }) &&
      isInsideViewport(element) &&
      !isClippedByAncestors(element)
    );
  }

  return (
    !isHiddenByStyle(element) &&
    !isHiddenByAncestor(element) &&
    isInsideViewport(element) &&
    !isClippedByAncestors(element)
  );
};

export default isElementVisible;
